/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const MULESOFT_LOCATIONS_API_V1_BASE_URL = new InjectionToken<string>('MULESOFT_LOCATIONS_API_V1_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class LocationsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(MULESOFT_LOCATIONS_API_V1_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:8080";
    }

    search(term: string, city: string | null | undefined, state: string | null | undefined, zipCode: string | null | undefined, longitude: number | null | undefined, latitude: number | null | undefined): Observable<SearchResponse> {
        let url_ = this.baseUrl + "/search?";
        if (term === undefined || term === null)
            throw new Error("The parameter 'term' must be defined and cannot be null.");
        else
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (city !== undefined && city !== null)
            url_ += "city=" + encodeURIComponent("" + city) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (zipCode !== undefined && zipCode !== null)
            url_ += "zipCode=" + encodeURIComponent("" + zipCode) + "&";
        if (longitude !== undefined && longitude !== null)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (latitude !== undefined && latitude !== null)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<SearchResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SearchResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchResponse>(<any>null);
    }

    /**
     * @return Request Successful
     */
    details(id: number): Observable<LocationDetailResponse> {
        let url_ = this.baseUrl + "/details/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetails(<any>response_);
                } catch (e) {
                    return <Observable<LocationDetailResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationDetailResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDetails(response: HttpResponseBase): Observable<LocationDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Resource Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationDetailResponse>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocationsSuggestionsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(MULESOFT_LOCATIONS_API_V1_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:8080";
    }

    /**
     * @param term The word or set of words a customer enters when searching for locations
     * @param city (optional) The city name that can narrow down suggestions to specific city
     * @param state (optional) The state abbreviation that can narrow down suggestions to specific state
     * @param zipCode (optional) The zip code that can narrow down suggestions to specific postal area
     * @param longitude (optional) The longitude that can narrow down suggestions to the smaller radius
     * @param latitude (optional) The latitude that can narrow down suggestions to the smaller radius
     */
    facilities(term: string, city: string | null | undefined, state: string | null | undefined, zipCode: string | null | undefined, longitude: number | null | undefined, latitude: number | null | undefined): Observable<SearchFacilitiesSuggestionsResponse[]> {
        let url_ = this.baseUrl + "/suggestions/facilities?";
        if (term === undefined || term === null)
            throw new Error("The parameter 'term' must be defined and cannot be null.");
        else
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (city !== undefined && city !== null)
            url_ += "city=" + encodeURIComponent("" + city) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (zipCode !== undefined && zipCode !== null)
            url_ += "zipCode=" + encodeURIComponent("" + zipCode) + "&";
        if (longitude !== undefined && longitude !== null)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (latitude !== undefined && latitude !== null)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFacilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacilities(<any>response_);
                } catch (e) {
                    return <Observable<SearchFacilitiesSuggestionsResponse[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SearchFacilitiesSuggestionsResponse[]>><any>_observableThrow(response_);
        }));
    }

    protected processFacilities(response: HttpResponseBase): Observable<SearchFacilitiesSuggestionsResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchFacilitiesSuggestionsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchFacilitiesSuggestionsResponse[]>(<any>null);
    }

    /**
     * @param term (optional) The word or set of words a customer enters when searching for locations
     * @param longitude (optional) The longitude that can narrow down suggestions to the smaller radius
     * @param latitude (optional) The latitude that can narrow down suggestions to the smaller radius
     */
    locations(term: string | null | undefined, longitude: number | null | undefined, latitude: number | null | undefined): Observable<SearchLocationsSuggestionsResponse[]> {
        let url_ = this.baseUrl + "/suggestions/locations?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (longitude !== undefined && longitude !== null)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (latitude !== undefined && latitude !== null)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocations(<any>response_);
                } catch (e) {
                    return <Observable<SearchLocationsSuggestionsResponse[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SearchLocationsSuggestionsResponse[]>><any>_observableThrow(response_);
        }));
    }

    protected processLocations(response: HttpResponseBase): Observable<SearchLocationsSuggestionsResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchLocationsSuggestionsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchLocationsSuggestionsResponse[]>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocationsAutocompleteService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(MULESOFT_LOCATIONS_API_V1_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:8080";
    }

    locations(term: string): Observable<SearchFacilitiesAutoCompleteResponse> {
        let url_ = this.baseUrl + "/blockit-autocomplete/locations?";
        if (term === undefined || term === null)
            throw new Error("The parameter 'term' must be defined and cannot be null.");
        else
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocations(<any>response_);
                } catch (e) {
                    return <Observable<SearchFacilitiesAutoCompleteResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SearchFacilitiesAutoCompleteResponse>><any>_observableThrow(response_);
        }));
    }

    protected processLocations(response: HttpResponseBase): Observable<SearchFacilitiesAutoCompleteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchFacilitiesAutoCompleteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchFacilitiesAutoCompleteResponse>(<any>null);
    }
}

export class SearchResponse implements ISearchResponse {
    currentPageNumber!: number;
    pageSize!: number;
    totalResults!: number;
    isMoreDataAvailable!: boolean;
    results!: Items[];

    constructor(data?: ISearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new Items(item) : <Items>item;
                }
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPageNumber = _data["currentPageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalResults = _data["totalResults"];
            this.isMoreDataAvailable = _data["isMoreDataAvailable"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Items.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPageNumber"] = this.currentPageNumber;
        data["pageSize"] = this.pageSize;
        data["totalResults"] = this.totalResults;
        data["isMoreDataAvailable"] = this.isMoreDataAvailable;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResponse {
    currentPageNumber: number;
    pageSize: number;
    totalResults: number;
    isMoreDataAvailable: boolean;
    results: IItems[];
}

export class SearchFacilitiesSuggestionsResponse implements ISearchFacilitiesSuggestionsResponse {
    /** A text that matched for suggestion */
    text!: string;

    constructor(data?: ISearchFacilitiesSuggestionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SearchFacilitiesSuggestionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFacilitiesSuggestionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data;
    }
}

export interface ISearchFacilitiesSuggestionsResponse {
    /** A text that matched for suggestion */
    text: string;
}

export class ErrorResponse implements IErrorResponse {
    message!: string;
    exception?: string | undefined;

    constructor(data?: IErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.exception = _data["exception"];
        }
    }

    static fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["exception"] = this.exception;
        return data;
    }
}

export interface IErrorResponse {
    message: string;
    exception?: string | undefined;
}

export class SearchLocationsSuggestionsResponse implements ISearchLocationsSuggestionsResponse {
    /** A suggestion for location */
    name!: string;

    constructor(data?: ISearchLocationsSuggestionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SearchLocationsSuggestionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLocationsSuggestionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISearchLocationsSuggestionsResponse {
    /** A suggestion for location */
    name: string;
}

export class SearchFacilitiesAutoCompleteResponse implements ISearchFacilitiesAutoCompleteResponse {
    term!: string;
    items!: any[];

    constructor(data?: ISearchFacilitiesAutoCompleteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.term = _data["term"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchFacilitiesAutoCompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFacilitiesAutoCompleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        return data;
    }
}

export interface ISearchFacilitiesAutoCompleteResponse {
    term: string;
    items: any[];
}

export class LocationDetailResponse implements ILocationDetailResponse {
    id?: number | undefined;
    name!: string;
    type!: string;
    phoneNumber!: string;
    website!: string;
    aboutLocation!: string;
    locationAvailability!: string;
    nearByLocationMarkers!: NearByLocationMarkers[];
    locationHours!: LocationHours[];
    address!: Address;
    services!: Services[];
    associatedProviders!: AssociatedProviders[];

    constructor(data?: ILocationDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.nearByLocationMarkers) {
                this.nearByLocationMarkers = [];
                for (let i = 0; i < data.nearByLocationMarkers.length; i++) {
                    let item = data.nearByLocationMarkers[i];
                    this.nearByLocationMarkers[i] = item && !(<any>item).toJSON ? new NearByLocationMarkers(item) : <NearByLocationMarkers>item;
                }
            }
            if (data.locationHours) {
                this.locationHours = [];
                for (let i = 0; i < data.locationHours.length; i++) {
                    let item = data.locationHours[i];
                    this.locationHours[i] = item && !(<any>item).toJSON ? new LocationHours(item) : <LocationHours>item;
                }
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
            if (data.services) {
                this.services = [];
                for (let i = 0; i < data.services.length; i++) {
                    let item = data.services[i];
                    this.services[i] = item && !(<any>item).toJSON ? new Services(item) : <Services>item;
                }
            }
            if (data.associatedProviders) {
                this.associatedProviders = [];
                for (let i = 0; i < data.associatedProviders.length; i++) {
                    let item = data.associatedProviders[i];
                    this.associatedProviders[i] = item && !(<any>item).toJSON ? new AssociatedProviders(item) : <AssociatedProviders>item;
                }
            }
        }
        if (!data) {
            this.nearByLocationMarkers = [];
            this.locationHours = [];
            this.address = new Address();
            this.services = [];
            this.associatedProviders = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.phoneNumber = _data["phoneNumber"];
            this.website = _data["website"];
            this.aboutLocation = _data["aboutLocation"];
            this.locationAvailability = _data["locationAvailability"];
            if (Array.isArray(_data["nearByLocationMarkers"])) {
                this.nearByLocationMarkers = [] as any;
                for (let item of _data["nearByLocationMarkers"])
                    this.nearByLocationMarkers!.push(NearByLocationMarkers.fromJS(item));
            }
            if (Array.isArray(_data["locationHours"])) {
                this.locationHours = [] as any;
                for (let item of _data["locationHours"])
                    this.locationHours!.push(LocationHours.fromJS(item));
            }
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : new Address();
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(Services.fromJS(item));
            }
            if (Array.isArray(_data["associatedProviders"])) {
                this.associatedProviders = [] as any;
                for (let item of _data["associatedProviders"])
                    this.associatedProviders!.push(AssociatedProviders.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["phoneNumber"] = this.phoneNumber;
        data["website"] = this.website;
        data["aboutLocation"] = this.aboutLocation;
        data["locationAvailability"] = this.locationAvailability;
        if (Array.isArray(this.nearByLocationMarkers)) {
            data["nearByLocationMarkers"] = [];
            for (let item of this.nearByLocationMarkers)
                data["nearByLocationMarkers"].push(item.toJSON());
        }
        if (Array.isArray(this.locationHours)) {
            data["locationHours"] = [];
            for (let item of this.locationHours)
                data["locationHours"].push(item.toJSON());
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        if (Array.isArray(this.associatedProviders)) {
            data["associatedProviders"] = [];
            for (let item of this.associatedProviders)
                data["associatedProviders"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocationDetailResponse {
    id?: number | undefined;
    name: string;
    type: string;
    phoneNumber: string;
    website: string;
    aboutLocation: string;
    locationAvailability: string;
    nearByLocationMarkers: INearByLocationMarkers[];
    locationHours: ILocationHours[];
    address: IAddress;
    services: IServices[];
    associatedProviders: IAssociatedProviders[];
}

export class Items implements IItems {
    id!: string;
    name!: string;
    type!: string;
    address!: Type;
    phoneNumber!: string;
    tollFreeNumber!: string;
    availability!: ItemsAvailability;
    image!: Type_1;

    constructor(data?: IItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Type(data.address) : <Type>this.address;
            this.image = data.image && !(<any>data.image).toJSON ? new Type_1(data.image) : <Type_1>this.image;
        }
        if (!data) {
            this.address = new Type();
            this.image = new Type_1();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.address = _data["address"] ? Type.fromJS(_data["address"]) : new Type();
            this.phoneNumber = _data["phoneNumber"];
            this.tollFreeNumber = _data["tollFreeNumber"];
            this.availability = _data["availability"];
            this.image = _data["image"] ? Type_1.fromJS(_data["image"]) : new Type_1();
        }
    }

    static fromJS(data: any): Items {
        data = typeof data === 'object' ? data : {};
        let result = new Items();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["tollFreeNumber"] = this.tollFreeNumber;
        data["availability"] = this.availability;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        return data;
    }
}

export interface IItems {
    id: string;
    name: string;
    type: string;
    address: IType;
    phoneNumber: string;
    tollFreeNumber: string;
    availability: ItemsAvailability;
    image: IType_1;
}

export class Type implements IType {
    addressLine1!: string;
    addressLine2!: string;
    city!: string;
    state!: string;
    zipCode!: string;
    latitude!: number;
    longitude!: number;

    constructor(data?: IType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): Type {
        data = typeof data === 'object' ? data : {};
        let result = new Type();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IType {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
    latitude: number;
    longitude: number;
}

export class Type_1 implements IType_1 {
    type!: string;
    name!: string;
    url!: string;
    size!: string;
    height!: number;
    width!: number;

    constructor(data?: IType_1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.size = _data["size"];
            this.height = _data["height"];
            this.width = _data["width"];
        }
    }

    static fromJS(data: any): Type_1 {
        data = typeof data === 'object' ? data : {};
        let result = new Type_1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["url"] = this.url;
        data["size"] = this.size;
        data["height"] = this.height;
        data["width"] = this.width;
        return data;
    }
}

export interface IType_1 {
    type: string;
    name: string;
    url: string;
    size: string;
    height: number;
    width: number;
}

export class NearByLocationMarkers implements INearByLocationMarkers {
    name!: string;
    phone!: string;
    website!: string;
    latitude?: number | undefined;
    longitude?: number | undefined;

    constructor(data?: INearByLocationMarkers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.website = _data["website"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): NearByLocationMarkers {
        data = typeof data === 'object' ? data : {};
        let result = new NearByLocationMarkers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["website"] = this.website;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface INearByLocationMarkers {
    name: string;
    phone: string;
    website: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
}

export class LocationHours implements ILocationHours {
    day?: string | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    is24Hours?: boolean | undefined;

    constructor(data?: ILocationHours) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.openTime = _data["openTime"];
            this.closeTime = _data["closeTime"];
            this.is24Hours = _data["is24Hours"];
        }
    }

    static fromJS(data: any): LocationHours {
        data = typeof data === 'object' ? data : {};
        let result = new LocationHours();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["openTime"] = this.openTime;
        data["closeTime"] = this.closeTime;
        data["is24Hours"] = this.is24Hours;
        return data;
    }
}

export interface ILocationHours {
    day?: string | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    is24Hours?: boolean | undefined;
}

export class Address implements IAddress {
    addressLine1!: string;
    addressLine2!: string;
    city!: string;
    state!: string;
    zipCode!: string;
    latitude?: number | undefined;
    longitude?: number | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IAddress {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
}

export class Services implements IServices {
    name!: string;
    description!: string;

    constructor(data?: IServices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Services {
        data = typeof data === 'object' ? data : {};
        let result = new Services();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IServices {
    name: string;
    description: string;
}

export class AssociatedProviders implements IAssociatedProviders {
    name!: string;
    specialty!: string;
    image!: Image;

    constructor(data?: IAssociatedProviders) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.image = data.image && !(<any>data.image).toJSON ? new Image(data.image) : <Image>this.image;
        }
        if (!data) {
            this.image = new Image();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.specialty = _data["specialty"];
            this.image = _data["image"] ? Image.fromJS(_data["image"]) : new Image();
        }
    }

    static fromJS(data: any): AssociatedProviders {
        data = typeof data === 'object' ? data : {};
        let result = new AssociatedProviders();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["specialty"] = this.specialty;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssociatedProviders {
    name: string;
    specialty: string;
    image: IImage;
}

export enum ItemsAvailability {
    Open = "open",
    Closed = "closed",
    _24Hours = "24Hours",
}

export class Image implements IImage {
    type!: string;
    name!: string;
    url!: string;
    size!: string;
    height!: number;
    width!: number;

    constructor(data?: IImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.size = _data["size"];
            this.height = _data["height"];
            this.width = _data["width"];
        }
    }

    static fromJS(data: any): Image {
        data = typeof data === 'object' ? data : {};
        let result = new Image();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["url"] = this.url;
        data["size"] = this.size;
        data["height"] = this.height;
        data["width"] = this.width;
        return data;
    }
}

export interface IImage {
    type: string;
    name: string;
    url: string;
    size: string;
    height: number;
    width: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
